import { Component, Inject, Input, OnInit } from '@angular/core';
import Windowsticker from '../../../../../model/product/windowsticker/windowsticker';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import WindowStickerPlacement from '../../../../../model/product/windowsticker/windowsticker-placement';
import { DatePipe } from '@angular/common';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import Asset from 'src/app/model/asset';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'windowsticker-details-dialog',
  templateUrl: './windowsticker-details-dialog.component.html',
  styleUrls: ['./windowsticker-details-dialog.component.scss'],
  providers: [FormatPhoneNumber],
})
export class WindowstickerDetailsDialogComponent implements OnInit {
  @Input()
  inputWindowSticker: Windowsticker;
  @Input()
  inputProject: Project;

  @Input()
  productPrice: string;

  index = 0;
  placement: WindowStickerPlacement;
  definitiveDesign: Asset[];
  isImmoscoop = false;
  isSpotto = false;

  constructor(
    public dialogRef: MatDialogRef<WindowstickerDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public datepipe: DatePipe,
    public formatPhoneNumber: FormatPhoneNumber
  ) {
    this.inputWindowSticker = data.product;
    this.placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    this.inputProject = data.project;
    this.productPrice = data.price;
    this.index = data.index;
  }

  ngOnInit() {
    this.setDefinitiveDesign();
    this.setImmoscoopAndSpotto();
  }

  getProductPrice() {
    return '-,-';
  }

  setDefinitiveDesign() {
    this.definitiveDesign = [];
    if (this.inputWindowSticker.productAssets) {
      for (let pa of this.inputWindowSticker.productAssets) {
        if (pa.formSection === 'internalDesign' && !pa.archived) {
          this.definitiveDesign.push(pa.asset);
        }
      }
    }
  }

  getPosition(): String {
    if (this.inputWindowSticker.productSize) {
      if (
        this.inputWindowSticker.productSize.width ===
        this.inputWindowSticker.productSize.height
      ) {
        return 'Vierkant';
      } else {
        return this.inputWindowSticker.productSize.width >
          this.inputWindowSticker.productSize.height
          ? 'Rechthoekig liggend'
          : 'Rechthoekig staand';
      }
    } else {
      return 'Geen product afmetingen opgegeven';
    }
  }

  getTitle(title: string) {
    return title == null || title === '' ? 'Geen titel' : title;
  }

  setImmoscoopAndSpotto(): boolean {
    if (
      this.inputProject.projectContacts == null ||
      this.inputProject.projectContacts.length === 0
    ) {
      this.isImmoscoop = false;
      this.isSpotto = false;
      return;
    }
    if (this.inputProject.projectContacts.length === 1) {
      this.isImmoscoop = this.inputProject.projectContacts[0].company.immoscoop;
      this.isSpotto = this.inputProject.projectContacts[0].company.spotto;
      return;
    }

    for (let i = 0; i < this.inputProject.projectContacts.length; i++) {
      let projectContact = this.inputProject.projectContacts[i];
      if (projectContact.projectManager) {
        this.isImmoscoop = projectContact.company.immoscoop;
        this.isSpotto = projectContact.company.spotto;
        return;
      }
    }

    this.isImmoscoop = false;
    this.isSpotto = false;
  }

  getColors(): string {
    if (
      this.inputWindowSticker.productCompanyPMSColors == null ||
      this.inputWindowSticker.productCompanyPMSColors.length === 0
    ) {
      return 'Geen kleuren geselecteerd';
    }

    let toReturn = '';
    for (
      let i = 0;
      i < this.inputWindowSticker.productCompanyPMSColors.length;
      i++
    ) {
      let pcp = this.inputWindowSticker.productCompanyPMSColors[i];
      if (i > 0) {
        toReturn += ', ' + pcp.pmsColor.name;
      } else {
        toReturn += pcp.pmsColor.name;
      }
    }
    return toReturn;
  }

  formatDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy');
  }

  close(): void {
    this.dialogRef.close();
  }
}
